import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints } from '@/styles'
import { ButtonBar } from '@/components/button-bar'
import { Button } from '@/components/button'

const StyledButtonBar = styled(ButtonBar)<{ isModal?: boolean }>`
  ${props =>
    props.isModal &&
    `
    height: auto;
    padding: 4px 8px 24px;
    border-top: none;
    z-index: unset;
    background: none;

    @media screen and (max-width: ${breakpoints.phoneMax}) {
      padding-bottom: 16px;
    }
  `}
`

type ButtonBarProps = {
  isModal: boolean
  handleBack: () => void
  handleDelete: () => void
  disabled: boolean
  primaryButtonText: string
}

const PadButtonBar: React.FC<ButtonBarProps> = ({
  isModal,
  handleBack,
  handleDelete,
  disabled,
  primaryButtonText
}) => {
  const { t } = useTranslation()

  return (
    <StyledButtonBar isModal={isModal} sticky={!isModal}>
      <Button theme="secondary" size={isModal ? 'medium' : 'small'} onClick={handleBack}>
        {isModal ? t('common.cancel', 'Cancel') : t('common.back', 'Back')}
      </Button>
      <Button theme="primary" size={isModal ? 'medium' : 'small'} type="submit" disabled={disabled}>
        {primaryButtonText}
      </Button>
    </StyledButtonBar>
  )
}

export default PadButtonBar
